import ClaimTypeAutomationRule from 'models/claims/claimTypeAutomationRule/Model.ClaimTypeAutomationRule';
import Model from 'models/Model';
import DealerGroup from '../dealerGroup/Model.DealerGroup';

export default class ClaimTypeDealerGroupAutomationRule
  extends Model<Model.IClaimTypeDealerGroupAutomationRule>({ icon: 'if-login' })
  implements Model.Instance<Model.IClaimTypeDealerGroupAutomationRule>
{
  id: number;
  logicalLayout: Model.Automation.ILayoutToken[];
  expressions: Model.Automation.IExpression[];
  effects: Model.Automation.IEffect[];

  claimTypeAutomationRuleId: number;
  claimTypeAutomationRule?: ClaimTypeAutomationRule;
  dealerGroupId: number;
  dealerGroup?: DealerGroup;

  claimTypeId?: number;

  constructor(
    data:
      | Partial<Model.IClaimTypeDealerGroupAutomationRule>
      | Utils.FormData<Model.IClaimTypeDealerGroupAutomationRule>,
    language?: Locale.Languages
  ) {
    super(
      {
        claimTypeAutomationRule: ClaimTypeAutomationRule,
        dealerGroup: DealerGroup,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.claimTypeAutomationRule?.claimType?.name || this.id?.toString(),
    };
  }
}
